import {
	styledSystem as ss,
	Box,
	IBoxProps,
} from ".";


// We define this so that props that are not supported are removed
export const BorderBox = ss.styled(Box)<IBoxProps>``;

BorderBox.defaultProps = {
	border: 1,
	borderColor: "border",
};